export default __webpack_public_path__ + "static/media/insta03.edca9c44.webp";